export default __webpack_public_path__ + "static/share-logo-d222d428b305529737d52292a65a6d65.jpg";